<template>
  <component
    v-if="component"
    :is="component"
    :locale="locale"
  />
</template>

<script>
import { getPaymentComponent } from './paymentRegistry'

export default {
  name: 'SeparatePament',

  props: [
    'locale'
  ],

  data () {
    return {
      component: null
    }
  },

  async mounted () {
    const pg = this.$route.params.pg
    const pgid = this.$route.params.pgid

    try {
      const res = await this.$store.dispatch('payment/getPgInfo', pgid)

      if (res) {
        this.$store.commit('payment/setPaymentInfo', res)

        this.component = getPaymentComponent(pg)
      }
    } catch (e) {
      this.component = null
    }
  }
}
</script>